import dateUtils from "utils/dateUtils";

export const MONTHS = {
  0: { value: "01", desc: "Январь", days: 31, translatePath:"other.months.0" },
  1: { value: "02", desc: "Февраль", days: 28, translatePath:"other.months.1" },
  2: { value: "03", desc: "Март", days: 31, translatePath:"other.months.2" },
  3: { value: "04", desc: "Апрель", days: 30, translatePath:"other.months.3" },
  4: { value: "05", desc: "Май", days: 31, translatePath:"other.months.4" },
  5: { value: "06", desc: "Июнь", days: 30, translatePath:"other.months.5" },
  6: { value: "07", desc: "Июль", days: 31, translatePath:"other.months.6" },
  7: { value: "08", desc: "Август", days: 31, translatePath:"other.months.7" },
  8: { value: "09", desc: "Сентябрь", days: 30, translatePath:"other.months.8" },
  9: { value: "10", desc: "Октябрь", days: 31, translatePath:"other.months.9" },
  10: { value: "11", desc: "Ноябрь", days: 30, translatePath:"other.months.10" },
  11: { value: "12", desc: "Декабрь", days: 31, translatePath:"other.months.11" },
};

export const DAYS = [
   { key:1, value: 1, desc: "Понедельник", translatePath: "other.days.mondayShort" },
   { key:2, value: 2, desc: "Вторник", translatePath: "other.days.tuesdayShort"  },
   { key:3, value: 3, desc: "Среда", translatePath: "other.days.wednesdayShort"  },
   { key:4, value: 4, desc: "Четверг", translatePath: "other.days.thursdayShort"  },
   { key:5, value: 5, desc: "Пятница", translatePath: "other.days.fridayShort"  },
   { key:6, value: 6, desc: "Суббота", translatePath: "other.days.saturdayShort"  },
   { key:7, value: 0, desc: "Воскресенье", translatePath: "other.days.sundayShort"  },
];

export const calendarDaysType = {
  MOCK: "mock",
  UNLOCK: "unlock",
  LOCK: "lock",
  PREV_LOCK: "prevLock"
};

const formatDay = (day) => {
  let formatDay = String(day).length > 1 ? String(day) : "0" + day;
  return formatDay;
};

const createCalendarDay = ({
  year,
  month,
  day,
  type = calendarDaysType.UNLOCK,
  unloading,
  uploading,
  unloadingApproved,
  uploadingApproved,
  unloadingNotApproved,
  uploadingNotApproved
}) => {
  return {
    id: `${year}-${month}-${formatDay(day)}`,
    year,
    month,
    day,
    type,
    unloading,
    uploading,
    unloadingApproved,
    uploadingApproved,
    unloadingNotApproved,
    uploadingNotApproved
  };
};

const getDaysInPrevMounth = (currentMonth) => {
  return currentMonth - 1 < 0 ? MONTHS[11].days : MONTHS[currentMonth - 1].days;
};
// const getDaysInNextMounth = (currentMonth) => {
//   return currentMonth + 1 > 11 ? MONTHS[0].days : MONTHS[currentMonth + 1].days;
// };

const getBeforMockDays = (
  firstDay,
  currentYear,
  prevMonthDays,
  currentMonth
) => {
  const mockDays = [];
  let indexTemp = 1;
  if (firstDay < 1) {
    indexTemp = 5;
  } else if (firstDay > 1) {
    indexTemp = firstDay - 2;
  } else {
    indexTemp = -1;
  }
  for (let index = indexTemp; index >= 0; index--) {
    const day = prevMonthDays - index;
    const month = MONTHS[currentMonth - 1 < 0 ? 11 : currentMonth - 1].value;
    const year = currentMonth - 1 < 0 ? currentYear - 1 : currentYear;
    mockDays.push(createCalendarDay({year, month, day, type:calendarDaysType.MOCK}));
  }
  return mockDays;
};

const getAfterMockDays = (lastDay, currentYear, currentMonth) => {
  const mockDays = [];
  if (lastDay !== 0) {
    let day = 0;
    for (let index = 0; index < 7 - lastDay; index++) {
      day++;
      let month = MONTHS[currentMonth + 1 > 11 ? 0 : currentMonth + 1].value;
      let year = currentMonth + 1 > 11 ? currentYear + 1 : currentYear;
      mockDays.push(createCalendarDay({year, month, day, type:calendarDaysType.MOCK}));
    }
  }
  return mockDays;
};

const getDayTonnage = (stringDate, daysTonnage) => { 
  const dayTonnage = daysTonnage.find(dayTonnage=>stringDate=== dayTonnage.day)
  return [dayTonnage.unloading, dayTonnage.uploading, dayTonnage.unloadingApproved, dayTonnage.uploadingApproved, dayTonnage.unloadingNotApproved, dayTonnage.uploadingNotApproved]
 }

 const checkBlockedDay = (blockedDays, stringDate) => {
  const blockedDay = blockedDays.find(blockedDate=>blockedDate=== stringDate)
   return Boolean(blockedDay)
  }

const getCurrentMontDays = (currentYear, currentMonth, daysTonnage, blockedDays) => {
  const currentDays = [];
  const currentDate = new Date();
  const month = MONTHS[currentMonth].value;
  const year = currentYear;
  for (let index = 1; index <= MONTHS[currentMonth].days; index++) {
    const stringDate = `${year}-${month}-${formatDay(index)}`;
    const newDate = new Date(stringDate);
    const [unloading, uploading, unloadingApproved, uploadingApproved, unloadingNotApproved, uploadingNotApproved] = getDayTonnage(stringDate, daysTonnage)
    currentDays.push(
      createCalendarDay({
        year,
        month,
        day:index,
        unloading,
        uploading,
        unloadingApproved,
        uploadingApproved,
        unloadingNotApproved,
        uploadingNotApproved,
        type: (dateUtils.compareDates(newDate, currentDate) === -1) ? calendarDaysType.PREV_LOCK : checkBlockedDay(blockedDays, stringDate) ? calendarDaysType.LOCK : calendarDaysType.UNLOCK
      })
    );
  }
  return currentDays;
};

export const initCalendar = ({ date = new Date(), daysTonnage = [], blockedDays=[] }) => {
  const calendar = [];
  const initDate = new Date(date);
  const currentMonth = initDate.getMonth();
  const currentYear = initDate.getFullYear();

  const firstDayDate = new Date(`${currentYear}-${currentMonth + 1}-01`);
  const lastDayDate = new Date(
    `${currentYear}-${currentMonth + 1}-${MONTHS[currentMonth].days}`
  );
  const firstDay = firstDayDate.getDay();
  const lastDay = lastDayDate.getDay();
  const prevMonthDays = getDaysInPrevMounth(date.getMonth());

  const beforeMockDays = getBeforMockDays(
    firstDay,
    currentYear,
    prevMonthDays,
    currentMonth
  );
  const currentMonthDays = getCurrentMontDays(currentYear, currentMonth, daysTonnage, blockedDays);
  const afterMockDays = getAfterMockDays(lastDay, currentYear, currentMonth);

  calendar.push(...beforeMockDays);
  calendar.push(...currentMonthDays);
  calendar.push(...afterMockDays);

  return calendar;
};
